import { Route, Routes } from "react-router-dom";
import PrivateRoutes from "../../core/routes/PrivateRoutes";
import { Layout } from "../../core/components/Layout";
import { GerenciarOrganizacao } from "../pages/GerenciarOrganizacao";
import { CriarEstabelecimentoOrganizacao } from "../pages/CriarEstabelecimentoOrganizacao";

interface IOrganizacaoRoutesProps {
    autenticado: boolean;
}

export const OrganizacaoRoutes = ({ autenticado }: IOrganizacaoRoutesProps) => {
    return (
        <Routes>
            <Route element={
                <Layout titulo="Organização">
                    <PrivateRoutes autenticado={autenticado} />
                </Layout>
            }>
                <Route path="/" index element={<GerenciarOrganizacao />} />
                <Route path="/estabelecimentos/criar" element={<CriarEstabelecimentoOrganizacao />} />
            </Route>
        </Routes>
    );
};
